<template>
  <li :class="{ [`variant-${variant}`]: variant }">
    <a
      v-stack-x:sm
      :href="href"
      :target="modal ? null : '_blank'"
      @click="$emit('click', $event)"
      :data-toggle="modal ? 'modal' : null"
      class="product-card-action"
    >
      <slot />
    </a>
  </li>
</template>

<script>
export default {
  props: {
    variant: String,
    href: [String, Array]
  },
  computed: {
    modal() {
      return this.href.indexOf('#') === 0;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/system';

.product-card-action {
  font: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 0;
  width: 100%;
  padding: 1em;
  margin: 0 auto;
  font-weight: 400;
  color: $color-gray-700;
  background-color: #fff;

  &:hover {
    color: $color-blue-400;
  }
}

.variant-primary {
  margin-top: 8px;
}

.variant-primary .product-card-action {
  padding: 1em;
  background-color: $color-blue-400;
  color: #fff;

  &:hover {
    background-color: $color-blue-700;
  }
}
</style>
